export const FIELD_TYPES = {
    DATE: 'date',
    DATE_NO_TIME: 'dateNoTime',
    BADGE: 'badge',
    MULTI_ENTITY: 'multiEntity',
    TEXT: 'text',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    ARRAY: 'array',
    OBJECT: 'object',
    LINK: 'link',
    PORT: 'port',
    ICON: 'icon',
    COLOR: 'color',
    IMAGE: 'image'
};